export default class TrafficControl {
  onAdd (map) {
    this._map = map
    this._btn = document.createElement('button')
    this._btn.className = 'mapboxgl-ctrl-icon fa-solid fa-road'
    this._btn.type = 'button'
    this._btn.title = 'Toggle Traffic'
    this._btn.onclick = this.toggleTraffic.bind(this)
    this._container = document.createElement('div')
    this._container.className = 'mapboxgl-ctrl-group mapboxgl-ctrl'
    this._container.appendChild(this._btn)
    return this._container
  }

  onRemove () {
    this._container.parentNode.removeChild(this._container)
    this._map = undefined
  }

  ensureTrafficSource () {
    const map = this._map
    if (!map.getSource('traffic')) {
      map.addSource('traffic', {
        type: 'vector',
        url: 'mapbox://mapbox.mapbox-traffic-v1',
      })
    }
  }

  toggleTraffic () {
    const map = this._map
    if (map.getLayer('traffic')) {
      this.removeTraffic()
    } else {
      this.addTraffic()
    }
  }

  addTraffic () {
    this.ensureTrafficSource()
    this._map.addLayer({
      'id': 'traffic',
      'type': 'line',
      'source': 'traffic',
      'source-layer': 'traffic',
      'layout': {
        'visibility': 'visible',
        'line-join': 'round',
        'line-cap': 'round',
      },
      'paint': {
        'line-width': {
          base: 1.5,
          stops: [
            [
              14,
              2.5,
            ],
            [
              20,
              15.5,
            ],
          ],
        },
        'line-color': [
          'case',
          [
            '==',
            'low',
            [
              'get',
              'congestion',
            ],
          ],
          '#97d079',
          [
            '==',
            'moderate',
            [
              'get',
              'congestion',
            ],
          ],
          '#e9fb42',
          [
            '==',
            'heavy',
            [
              'get',
              'congestion',
            ],
          ],
          '#ee914e',
          [
            '==',
            'severe',
            [
              'get',
              'congestion',
            ],
          ],
          '#b43b3b',
          '#000000',
        ],
      },
    })
  }

  removeTraffic () {
    const map = this._map
    if (map.getLayer('traffic')) {
      map.removeLayer('traffic')
    }
  }
}
